import { useTranslate } from '@/utils/translate/translate-client'

export const useSubmissionRules = () => {
  const { t } = useTranslate('create')

  const allSubmissionsRules = [
    t('noNudity', 'No nudity'),
    t('noSexualActs', 'No sexual acts shown on screen'),
    t('noFWord', 'No use of the word F**k'),
    t('noLordsName', "No use of the Lord's name in vain"),
    t('noFilmmakerExplainer', 'No filmmaker explainer videos or speeches'),
    t('noAwardsReference', 'No reference to awards or other productions'),
  ]

  const episodeRules = [
    t(
      'noCreditsWebsites',
      'No credits, websites, QR codes, company logos, company names; however, Documentary/Reality participant names are allowed to be shown',
    ),
  ]

  const torchRules = [
    t('animatedTorches2Plus', 'Animated Torches are 2+ minutes'),
    t('otherTorches5Plus', 'Other Torches are 5+ minutes'),
    t('torchesLessThan20', 'Should be less than 20 minutes'),
    t('torchContinuousSequence', 'Must be a continuous sequence (or 2 to 3 scenes put together)'),
    t('trailersNotAcceptable', 'No trailers or sizzles'),
    t('torchGenreFormat', 'The genre and format must represent the final production'),
    t(
      'noCreditsWebsites',
      'No credits, websites, QR codes, company logos, company names; however, Documentary/Reality participant names are allowed to be shown',
    ),
  ]

  const teenagerRules = [t('allOfTheAbove', 'All of the above'), t('noCWord', 'Plus no use of the word C**t')]

  const youngerKidsRules = [t('allOfTheAbove', 'All of the above'), t('noSwearing', 'Plus no swearing of any kind')]

  const unbiasedRules = [
    t(
      'onceYourSubmissionIsApproved',
      "Once your submission is approved, we place it in a random queue with other submissions to keep the Guild score fair and accurate. While it's in voting, it won't be searchable by voters.",
    ),
    t(
      'toMaintainTheIntegrityOfTheVotingProcess',
      'To maintain the integrity of the voting process, the scoring algorithm is currently kept confidential. This includes information about the number of voters and other specific voting details.',
    ),
  ]

  return {
    allSubmissionsRules,
    episodeRules,
    torchRules,
    teenagerRules,
    youngerKidsRules,
    unbiasedRules,
  }
}
